import type { TFunction } from "i18next";
import { Icon } from "../../Icon";

const ElectricChargingWidget = ({ hasElectricCharging, t }: { hasElectricCharging: boolean; t: TFunction; }) => {
    // if not present, we assume the API doesn't provide this info and we hide the widget entirely
    if (!hasElectricCharging) return null;

    return (
        <div className="relative overflow-hidden rounded-2xl border border-primary/20 bg-primary/5 transition-all duration-300">
            <div className="p-5 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    {/* Icon with dynamic status indicator */}
                    <div className="relative">
                        <div className="bg-primary/10 text-primary rounded-2xl p-2.5 flex items-center justify-center shrink-0 border border-primary/20">
                            <Icon name="ev_station" className="text-2xl" />
                        </div>
                    </div>

                    <div>
                        <h3 className="text-[10px] font-black uppercase tracking-[0.2em] opacity-40 mb-1">
                            {t('poiModal.services')}
                        </h3>
                        <p className="text-sm font-black leading-tight uppercase text-primary">
                            {t('poiModal.hasElectricChargingAvailable')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ElectricChargingWidget;